import { Action } from '../../../actions';
import {
    CLOSE_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_BULK_CPM_IMAGE_CREATIVE_REPLACEMENT_EDITOR
} from '../../../actions/banners-edit/banners-edit-mass-actions';
import { MASS_UPDATE_BANNER_CREATIVE_DATA, UPDATE_BANNER_CREATIVE_ID } from '../../../actions/creative';
import { mapCreativeData } from '../../../mappers/creative';
import { getErrorForCreativeGroup } from '../../../service/BannersEditMassActionsHelpers/BannersEditMassActionsHelpers';
import { BannersEditMassActionsState, MassActionId } from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

import { bannersEditMassActionsInitialState } from './banners-edit-mass-actions';

export const bannersEditMassActionCpmImageCreativeReplaceReducer = (
    state: BannersEditMassActionsState = bannersEditMassActionsInitialState,
    action: Action,
    fullState: State
): BannersEditMassActionsState => {
    switch (action.type) {
        case UPDATE_BANNER_CREATIVE_ID:
            if (action.id !== MassActionId.bannersEdit) {
                return state;
            }

            return {
                ...state,
                [action.id]: {
                    ...state[action.id],
                    errors: [],
                    inProgress: true
                }
            };
        case MASS_UPDATE_BANNER_CREATIVE_DATA:
            const prevCreative = fullState.creative[action.bannerId];
            const additionalData = action.creatives.map(curCreative => mapCreativeData(prevCreative.data, curCreative));

            return {
                ...state,
                [action.bannerId]: {
                    ...state[action.bannerId],
                    inProgress: false,
                    errors: getErrorForCreativeGroup(additionalData)
                }
            };
        case ON_ACCEPT_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR:
        case CLOSE_MASS_ACTIONS_CPM_CREATIVE_BULK_REPLACEMENT_EDITOR:
            return bannersEditMassActionsInitialState;
        case OPEN_MASS_ACTIONS_BULK_CPM_IMAGE_CREATIVE_REPLACEMENT_EDITOR:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    visibleModalActions: {
                        ...state[action.massActionId].visibleModalActions,
                        cpmImageCreativeBulkReplacementEditorVisible: true
                    }
                }
            };
        default:
            return state;
    }
};
